@if (inVisualFilter().length > 0) {
  @for (filter of inVisualFilter(); track filter.fieldName; let idx = $index) {
    <div
      #element
      class="filter flex {{ filter.options.appearance }}"
      [class.active]="activeFilter === filter.localStorage.title"
      [class.multi]="filter.type === 'multiValueSelector'"
      [ngStyle]="filterContainerStyle(filter)"
    >
      @switch (filter.options.appearance) {
        @case ('timeline') {
          <timeline-control
            [items]="filter.localStorage.filterObjects"
            [(selected)]="filter.selectedValue"
            (selectedChange)="updateFilter(filter)"
            [style]="style()"
          >
          </timeline-control>
        }

        @case ('slider') {
          @if (filter.options.playButton.enabled && filter.options.playButton.position === 'left') {
            <div class="play-button cursor-pointer" (click)="playButtonClick(filter)">
              <i class="icon-{{ filter.localStorage.playButton.active ? 'pause' : 'play' }}"></i>
            </div>
          }

          <items-slider
            [style]="style()"
            [items]="filter.localStorage.filterObjects"
            [(selected)]="filter.selectedValue"
            (selectedChange)="updateFilter(filter)"
          >
          </items-slider>

          @if (filter.options.playButton.enabled && filter.options.playButton.position === 'right') {
            <div class="play-button cursor-pointer" (click)="playButtonClick(filter)">
              <i class="icon-{{ filter.localStorage.playButton.active ? 'pause' : 'play' }}"></i>
            </div>
          }
        }

        <!-- TODO make drodown dependant on filter Type -->
        @case ('dropdown') {
          <menu-button
            [close]="closeSelect"
            [hideShadow]="true"
            [withBackdrop]="false"
            #dropdownMenuButtons
            [autoclose]="true"
            [overlayStyle]="{ borderTopLeftRadius: 0 }"
            [menuStyle]="{ backgroundColor: 'transparent' }"
            (isOpen)="opened($event, filter.localStorage.title)"
            [originPosition]="getPopupPosition(filter.localStorage.title).originPosition"
            [overlayPosition]="getPopupPosition(filter.localStorage.title).overlayPosition"
            [showOverflow]="true"
            [connectToElement]="element"
          >
            <button class="title center flex" button>
              @if (filter.type === 'valueSelector') {
                {{ getFilterTitle(filter) }}
              } @else {
                {{ filter.options.title }}

                @if (filter.selectedValues.length > 0 && filter.selectedValues.length !== filter.localStorage.filterObjects.length) {
                  <span class="counter center flex">
                    {{ filter.selectedValues.length }}
                  </span>
                }
              }

              <div class="open-icon" [class.rotate-180]="dropdownMenuButtons.open">
                <i class="icon-down-open center flex"></i>
              </div>
              <!-- <div class="down-arrow"></div> -->
            </button>

            <div
              #list
              class="list"
              [style.transform]="editor && displayScale() !== 1 ? 'scale(' + displayScale() + ')' : null"
              [style.transformOrigin]="editor && displayScale() !== 1 ? 'top left' : null"
              [style.minWidth.px]="element.clientWidth"
              [style.padding]="dropDownStyle().container.padding | responsiveStyle: 'spacing'"
              [style.boxShadow]="dropDownStyle().container.boxShadow | responsiveStyle: 'shadow'"
              [style.borderRadius.px]="dropDownStyle().container.borderRadius"
              [style.backgroundColor]="dropDownStyle().container.background.backgroundColor"
            >
              <list-selector
                [items]="filter.localStorage.filterObjects"
                [multiSelect]="filter.type === 'multiValueSelector'"
                [ngModel]="filter.type === 'valueSelector' ? filter.selectedValue : filter.localStorage.selectedValues"
                [placeholder]="dropDownStyle().search.placeholder"
                [itemFont]="dropDownStyle().items.font | responsiveStyle"
                [itemInactiveOpacity]="dropDownStyle().items.inactive.opacity"
                [itemMouseOver]="{
                  backgroundColor: dropDownStyle().items.mouseOver.background.backgroundColor,
                  color: dropDownStyle().items.mouseOver.color,
                }"
                [itemActive]="{ backgroundColor: dropDownStyle().items.active.background.backgroundColor, color: dropDownStyle().items.active.color }"
                [selectAllText]="dropDownStyle().selectAllButton.label"
                [showSearch]="dropDownStyle().search.enabled"
                [trackByFn]="trackByFunction"
                [autoSort]="dropDownStyle().items.ordering.enabled"
                [sortDesc]="dropDownStyle().items.ordering.desc"
                [measureElement]="element"
                [sortByField]="filter.localStorage.type === 'date' ? 'dateValue' : null"
                (newPositions)="setPopupPositions(filter.localStorage.title, $event)"
                (ngModelChange)="setValues(filter, $event)"
              ></list-selector>
            </div>
          </menu-button>
        }

        @case ('buttons') {
          <div [ngStyle]="getButtonsGroupStyle(idx)">
            @for (item of filter.localStorage.filterObjects; track item.value; let idx2 = $index) {
              <button
                class="btn hover:opacity-70"
                [class.active]="filter.selectedValue === item.value"
                [ngStyle]="getButtonStyle(idx, filter.selectedValue === item.value)"
                (click)="filter.selectedValue = item.value; updateFilter(filter)"
              >
                <span>{{ item.label }}</span>
              </button>
            }
          </div>
        }
      }
    </div>
  }
}
